import type { Locale } from '@lemonade-hq/lemonation';
import type { Config as PpmConfig } from './pay-per-mile/us/en';
import { config as enUsPpmConfig } from './pay-per-mile/us/en';
import type { Config as USConfig } from './us/en';
import { config as enUsConfig } from './us/en';

export type Config = USConfig | PpmConfig;

export const carTemplateConfig = {
  'en-US': enUsConfig,
  'en-GB': enUsConfig,
  'en-FR': enUsConfig,
  'en-DE': enUsConfig,
  'en-NL': enUsConfig,
  'nl-NL': enUsConfig,
  'de-DE': enUsConfig,
  'fr-FR': enUsConfig,
} as Record<Locale, Config>;

export const carPpmTemplateConfig = {
  'en-US': enUsPpmConfig,
  'en-GB': enUsPpmConfig,
  'en-FR': enUsPpmConfig,
  'en-DE': enUsPpmConfig,
  'en-NL': enUsPpmConfig,
  'nl-NL': enUsPpmConfig,
  'de-DE': enUsPpmConfig,
  'fr-FR': enUsPpmConfig,
} as Record<Locale, Config>;
